import {
  TextInput,
  PasswordInput,
  Checkbox,
  Anchor,
  Paper,
  Title,
  Text,
  Container,
  Group,
  Button,
  LoadingOverlay,
  Box,
  Flex,
} from "@mantine/core";
import classes from "./AuthenticationTitle.module.css";
import {
  readLocalStorageValue,
  useDisclosure,
  useLocalStorage,
  useOs,
} from "@mantine/hooks";
import { hasLength, isEmail, useForm } from "@mantine/form";
import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoginModel } from "../../../model/LoginModel";

import { isNullOrEmpty } from "../../extension/StringExtension";
import { AuthProvider } from "../../helper/IAuthProvider";
import {
  IconArrowNarrowRight,
  IconHttpPost,
  IconLock,
  IconUser,
} from "@tabler/icons-react";
import style from "./AuthenticationTitle.module.css";
import { NotificationExtension } from "../../extension/NotificationExtension";

export function AuthenticationTitle() {
  //#region  state
  const entity = {
    // username: "tester01",
    // password: "aA@123456",
    username: "",
    password: "",
    remember: false,
    os: "",
    location: "",
  };
  const form = useForm<LoginModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      username: (value) =>
        value.length < 5 || value.length > 50
          ? "Tên đăng nhập phải từ 5-50 kí tự!"
          : null,
      password: hasLength(
        { min: 6, max: 49 },
        "Mật khẩu phải lớn hớn 6 và nhỏ hơn 50 kí tự !"
      ),
    },
  });
  const navigate = useNavigate();

  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [visible1, setvisible1] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackParam = queryParams.get("callback");
  const [value, setValue] = useLocalStorage({
    key: "user-login",
    defaultValue: false,
  });
  const [locationVC, setLocation] = useState("");

  //#endregion
  function success(position: { coords: { latitude: any; longitude: any } }) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation("latitude: " + latitude + "-" + " longitude: " + longitude);
  }

  function error1() {
    console.log("Unable to retrieve your location");
  }
  //#region use
  //#region  auth
  const isAuthenticated = AuthProvider.isAuthenticated();
  const os = useOs();
  const handleLogin = async (dataSubmit: LoginModel) => {
    open();
    setvisible1(true);
    dataSubmit.os = os;
    dataSubmit.location = locationVC;

    const resLogin = await AuthProvider.signin(dataSubmit);
    if (
      resLogin !== undefined &&
      !isNullOrEmpty(resLogin.data?.jwt) &&
      resLogin.success
    ) {
      NotificationExtension.Success(
        resLogin?.message ?? "Đăng nhập thành công !"
      );
      if (callbackParam?.includes("login")) navigate("/");
      else navigate(callbackParam ?? "/");
      setValue(true);
      // này là push trực tiếp với điều kiện là app không tắt
      const registrationReady = await navigator.serviceWorker.ready;
      if (registrationReady && registrationReady.active)
        if (AuthProvider.isAuthenticated()) {
          const getUser = resLogin.data.userName;
          const empId = resLogin.data.empId;
          if (getUser && empId) {
            const postData = {
              userName: getUser,
              empId: empId,
              type: "listen",
              typeHandler: "login",
            };
            registrationReady.active?.postMessage(postData);
          }
        }
    } else if (resLogin?.httpStatusCode === 200)
      NotificationExtension.Fails(resLogin?.message ?? "Đăng nhập thất bại !");
    setvisible1(false);
    close();
  };

  const openRouter = () => {
    navigate("/auth/forget-password");
  };

  useEffect(() => {
    if (isAuthenticated === true) {
      navigate(callbackParam ?? "/");
    }
  });
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error1);
    } else {
      console.log("Geolocation not supported");
    }
  }, []);
  return (
    <>
      <Flex mb={40} direction="column">
        <Title c="#342e79" fw={500} order={3}>
          Chào mừng trở lại!
        </Title>
        <Text c="#8e8e8e" fw="400" size="sm">
          Xin hãy đăng nhập vào tài khoản của bạn
        </Text>
      </Flex>
      <Box
        component="form"
        m={0}
        p={0}
        className={style.form}
        onSubmit={form.onSubmit(async (e: LoginModel) => {
          await handleLogin(e);
        })}
      >
        <LoadingOverlay
          visible={visible1}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Paper pb={50} bg={"transparent"}>
          <TextInput
            radius="xl"
            label={
              <Text c="#342e79" mb={5} size="sm" fw="bold">
                Tên người dùng
              </Text>
            }
            leftSection={<IconUser size={20} />}
            size="lg"
            placeholder="Tên người dùng"
            mt="md"
            {...form.getInputProps("username")}
          />
          <PasswordInput
            radius="xl"
            label={
              <Text c="#342e79" mb={5} size="sm" fw="bold">
                Mật khẩu
              </Text>
            }
            leftSection={<IconLock size={20} />}
            size="lg"
            placeholder="Mật khẩu của bạn"
            mt="md"
            {...form.getInputProps("password")}
          />
          <Group justify="flex-end" mt="lg">
            <Anchor
              onClick={openRouter}
              fw={600}
              c="#342e79"
              td="underline"
              size="sm"
            >
              Quên mật khẩu
            </Anchor>
          </Group>

          <Button
            rightSection={<IconArrowNarrowRight color="#fff" size={24} />}
            type="submit"
            fullWidth
            bg="#342e79"
            mt="md"
            className={style.button_submit}
            size="lg"
            radius="xl"
          >
            <Text c={"#fff"} fw={500} size="lg" tt="capitalize">
              Đăng nhập
            </Text>
          </Button>
        </Paper>
        {/* <Group justify="end">
          <Text size="xs">
            <Flex gap={4}>
              Copyright © 2024{" "}
              <Text fw={600} c="#000">
                Hacom.
              </Text>{" "}
              All rights reserved.
            </Flex>
          </Text>
        </Group> */}
      </Box>
    </>
  );
}
